module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px 35px"
    }
  }, [(_vm.messages.length > 0) ? _c('div', {
    staticClass: "message-tabs"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("notifications.notifications")))]), _vm._v(" "), _vm._l((_vm.message_groups), function(mGroup) {
    return _c('div', {
      key: mGroup.key,
      attrs: {
        "title": mGroup.title
      },
      on: {
        "click": function($event) {
          return _vm.showMessages(mGroup)
        }
      }
    }, [_c('div', {
      class: mGroup.status_class
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.groupMessages(mGroup.key).length))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "show": _vm.messages_modal
    },
    on: {
      "hide": function($event) {
        _vm.messages_modal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "message-tabs"
  }, [_vm._l((_vm.messageGroupStatuses(_vm.selectedGroupMessages)), function(status) {
    return _c('div', [_c('div', {
      class: ['status', status]
    }), _vm._v(" " + _vm._s(_vm.MESSAGE_STATUSES[status]) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.messageGroupFailures(_vm.selectedGroupMessages)), function(failure) {
    return _c('div', [_c('div', {
      class: _vm.failureStatusClass(failure)
    }), _vm._v(" "), (failure in _vm.FAILURE_STATUSES) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.FAILURE_STATUSES[failure].title) + "\n          ")]) : _c('div', [_vm._v(_vm._s(failure))])])
  })], 2), _vm._v(" "), _c('MessageGroupList', {
    attrs: {
      "messages": _vm.selectedGroupMessages,
      "failure_statuses": _vm.FAILURE_STATUSES
    }
  })], 1)]), _vm._v(" "), _c('div')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93b2d256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/MarkerMessages.vue
// module id = 1064
// module chunks = 1